export default {
  titulo: 'Most common questions',
  subtitulo: {
    parte1: 'We separate the most common questions by topics. If your question is not answered,',
    parte2: ' contact us.',
  },
};
